module.exports = __webpack_public_path__ + "img/wa_police_logo.70841db5.png";